import React from 'react';
import DsLabel from './index';

const LabelError = ({ children }) => (
        <DsLabel icon="cross"
                 className="text-base"
                 iconClassName="text-2xl p-1 border rounded-full text-status-red border-status-red">
          {children}
        </DsLabel>
);

export default LabelError;
